var map = {
	"./symbol_0.png": 24795,
	"./symbol_1.png": 10578,
	"./symbol_2.png": 17641,
	"./symbol_3.png": 46464,
	"./symbol_4.png": 97791,
	"./symbol_5.png": 1462,
	"./symbol_6.png": 83085,
	"./symbol_7.png": 43140,
	"./symbol_8.png": 803,
	"./symbol_9.png": 99578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19422;